// AN ENGAGEMENT'S OR A JOB'S DEFAULT ISSUER, which may be "טרם הוחלט" (migration 074).
//
// One place for the option and the label, so the retainer / project form, the job form
// and every screen that prints the default say it the same way. Undecided is the empty
// value — the server stores it as NULL. Since 068 the issuer decides no money: each
// payment names who collected it.
//
// NOT for the dialog that records a charge by hand: that records a real invoice from one
// partner's software, so its issuer is a fact and the dialog offers partners only.
import he from '../i18n/he';

export const UNDECIDED = '';

export const issuerOptions = (partners) => [
  { value: UNDECIDED, label: he.jobs.issuerUndecided },
  ...(partners || []).map((p) => ({ value: p.id, label: p.name })),
];

// The default's name as a screen prints it.
export const issuerName = (name) => name || he.jobs.issuerUndecided;
